<rid-number-writing (finished)="$router.navigate(['/mechanics/formule'])" [numbers]="[420, 67, 1337]" class="h-dvh" />
